import { Button } from 'components/admin/ui';
import { ConfirmationModal } from 'components/admin/ui/ConfirmationModal';
import { AlertTriangle, RefreshCw01 } from 'ethena-icons';
import { useMemo, useState } from 'react';
import { getImpersonatedUser } from './api';
import { getRedirectPath } from './helpers';
import { ImpersonationEvent } from './types';

interface IImpersonationEventModalProps {
  event: ImpersonationEvent | null;
}

export const ImpersonationEventModal = ({
  event,
}: IImpersonationEventModalProps) => {
  const [isReloading, setIsReloading] = useState<boolean>(false);

  const confirmationProps = useMemo(() => {
    switch (event) {
      case ImpersonationEvent.STARTED:
        return {
          heading: 'Impersonation session started',
          details:
            'An impersonation session has started in another tab. Please reload this tab to continue.',
        };
      case ImpersonationEvent.ENDED:
        return {
          heading: 'Impersonation session ended',
          details:
            'The impersonation session was ended in another tab. Please reload this tab to continue.',
        };
      default:
        return null;
    }
  }, [event]);

  const handleReloadTabClick = async () => {
    setIsReloading(true);
    const res = await getImpersonatedUser();
    window.location.href = getRedirectPath(res.data);
  };

  return (
    <ConfirmationModal isVisible={!!event} onClose={undefined}>
      <ConfirmationModal.Header>
        <ConfirmationModal.Icon color="yellow" icon={AlertTriangle} />
      </ConfirmationModal.Header>

      <ConfirmationModal.Body>
        <ConfirmationModal.Confirmation {...confirmationProps} />
      </ConfirmationModal.Body>

      <ConfirmationModal.Footer>
        <Button
          icon={RefreshCw01}
          isLoading={isReloading}
          onClick={handleReloadTabClick}
        >
          Reload Tab
        </Button>
      </ConfirmationModal.Footer>
    </ConfirmationModal>
  );
};
